// src/components/routes/Sign/Register/Register.js

import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import RegisterAadhar from "./RegisterAadhar";
import RegisterPassport from "./RegisterPassport";
import "./Register.css"

const Register = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const [alertType, setAlertType] = useState('text');
    const [email, setEmail] = useState('');
    const [formData, setFormData] = useState({
        username: "",
        telephone: "",
        email: "",
        password: "",
        confirm_password: "",
        address: "",
        card_select: "Aadhar",
        card_detail: "",
        company_name: "",
        company_gst: "",
        transactionId: "",
        fwdp: "",
        codeVerifier: "",
        totalAttempts: 0,
        phone: "",
        countryCode: "",
        passportFile: null
    });

    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            setAlertMessage(null);

            const response = await axios.get(`${process.env.REACT_APP_API_URL}/verify/registration/${email}`);
            const { data } = response;

            if (!data.success) {
                setAlertMessage(data.message || 'Failed to check email registration');
                setAlertType('error');
                return;
            }

            // If user is already registered (verified = yes)
            if (data.verified === 'yes') {
                navigate('/login');
                return;
            }

            // If user exists in website_registration
            if (data.data) {
                const userData = data.data;
                setFormData(prev => ({
                    ...prev,
                    username: `${userData.f_name} ${userData.l_name}`,
                    telephone: userData.phone,
                    email: userData.email,
                    address: userData.address || '',
                    company_name: userData.company_name || '',
                    countryCode: userData.country_code || 'IN',
                    card_select: userData.card_type || 'Aadhar'
                }));
            } else {
                // New registration
                setFormData(prev => ({
                    ...prev,
                    email: email,
                    card_select: 'Aadhar'
                }));
            }

        } catch (error) {
            if (error.response?.status === 404) {
                setAlertMessage('Please complete the payment process first.');
            } else {
                setAlertMessage(error.response?.data?.message || 'Failed to check email registration');
            }
            setAlertType('error');
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return (
            <div className="register-container">
                <div className="loading">Loading...</div>
            </div>
        );
    }

    // If email is not yet submitted, show email form
    if (!formData.email) {
        return (
            <div className="register-container">
                <form onSubmit={handleEmailSubmit} className="email-form">
                    <h2 className="email-form-title">Please enter your email</h2>
                    
                    <div className="form-group">
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            className="email-input"
                            required
                        />
                    </div>

                    {alertMessage && (
                        <div className={`alert ${alertType}`}>
                            {alertMessage}
                        </div>
                    )}
                    <button type="submit" className="submit-email-button">
                        Continue
                    </button>
                </form>
            </div>
        );
    }

    // If email is submitted, show appropriate registration form
    return (
        <div className="register-container">
            {formData.card_select === 'Aadhar' ? (
                <RegisterAadhar formData={formData} />
            ) : (
                <RegisterPassport formData={formData} />
            )}
        </div>
    );
};

export default Register;
